import React from 'react';
import "../template-file-css/document-file-template.css";


export const GHP_PhysicianFollowUp = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_PhysicianFollowUp' className='file-pdf-document'>
            <div className='file-template'>
                <p>
                    <span className="eleHeader">Is the above diagnosis current?</span></p>
                <table>
                    <tr>
                        <td className='w-125'>
                            <input type="radio" id="rbDiagnosisCurrent_Yes" name="rbDiagnosisCurrent" className="add-only" value="Yes" />Yes
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbDiagnosisCurrent_No" name="rbDiagnosisCurrent" className="add-only" value="No" />No
                        </td>
                    </tr></table>
                <p>
                    If no, please identify the current diagnosis where indicated within this progress note
                    <textarea id="txtDiagnosisCurrent_No" name="txtDiagnosisCurrent_No" className=" add-only"></textarea>

                </p>


                <h3>HISTORY OF BEHAVIORAL SYMPTOMS</h3>

                <p>
                    <span className="eleHeader">Subjective: </span>
                    <textarea id="txtSubjective" name="txtSubjective" className=" add-only"></textarea>
                </p>

                <h3>Current Mental Status Examination:</h3>

                <table>
                    <tr>
                        <td className='w-750'><span className="eleHeader w-750;">Orientation:</span></td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbOrientation1" name="cbOrientation_1" className="add-only" value="Orientation_1" />Person</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbOrientation2" name="cbOrientation_2" className="add-only" value="Orientation_2" />Place</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbOrientation3" name="cbOrientation_3" className="add-only" value="Orientation_3" />Time</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbOrientation4" name="cbOrientation_4" className="add-only" value="Orientation_4" />Situation</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className="eleHeader w-750;">Appearance:</span></td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbAppearance1" name="cbAppearance_1" className="add-only" value="Appearance_1" />Neat</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbAppearance2" name="cbAppearance_2" className="add-only" value="Appearance_2" />Fastidious</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbAppearance3" name="cbAppearance_3" className="add-only" value="Appearance_3" />Casual</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbAppearance4" name="cbAppearance_4" className="add-only" value="Appearance_4" />Flamboyant</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbAppearance5" name="cbAppearance_5" className="add-only" value="Appearance_5" />Bizarre</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbAppearance6" name="cbAppearance_6" className="add-only" value="Appearance_6" />Disheveled</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className="eleHeader w-750;">Demeanor:</span></td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbDemeanor11" name="cbDemeanor_1" className="add-only" value="Demeanor_1" />Demanding</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbDemeanor12" name="cbDemeanor_2" className="add-only" value="Demeanor_2" />Friendly</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbDemeanor13" name="cbDemeanor_3" className="add-only" value="Demeanor_3" />Hostile </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbDemeanor14" name="cbDemeanor_4" className="add-only" value="Demeanor_4" />Manipulative</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbDemeanor1" name="cbDemeanor_5" className="add-only" value="Demeanor_5" />Negative </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbDemeanor2" name="cbDemeanor_6" className="add-only" value="Demeanor_6" />Aloof </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbDemeanor3" name="cbDemeanor_7" className="add-only" value="Demeanor_7" />Happy </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbDemeanor4" name="cbDemeanor_8" className="add-only" value="Demeanor_8" />Angry</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbDemeanor" name="cbDemeanor_9" className="add-only" value="Demeanor_9" />Other</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="text" id="txtDemeanor_9" name="txtDemeanor_9" className="add-only" />
                        </td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className="eleHeader w-750;">Behavior:</span></td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbBehavior1" name="cbBehavior_1" className="add-only" value="Behavior_1" />Tics </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbBehavior2" name="cbBehavior_2" className="add-only" value="Behavior_2" />Tremors</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbBehavior3" name="cbBehavior_3" className="add-only" value="Behavior_3" />Fidgety</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbBehavior4" name="cbBehavior_4" className="add-only" value="Behavior_4" />Hyperactive  </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbBehavior5" name="cbBehavior_5" className="add-only" value="Behavior_5" />Akathisia</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbBehavior6" name="cbBehavior_6" className="add-only" value="Behavior_6" />Hand Wringing</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbBehavior7" name="cbBehavior_7" className="add-only" value="Behavior_7" />Tardive Dyskinesia</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbBehavior8" name="cbBehavior_8" className="add-only" value="Behavior_8" />Cooperative</td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbBehavior9" name="cbBehavior_9" className="add-only" value="Behavior_9" />Responsive to redirection</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className="eleHeader w-750;">Mood:</span></td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMood1" name="cbMood_1" className="add-only" value="Mood_1" />Calm </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMood2" name="cbMood_2" className="add-only" value="Mood_2" />Hyper </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMood3" name="cbMood_3" className="add-only" value="Mood_3" />Euthymic</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMood4" name="cbMood_4" className="add-only" value="Mood_4" />Elevated  </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMood5" name="cbMood_5" className="add-only" value="Mood_5" />Dysphoric</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMood6" name="cbMood_6" className="add-only" value="Mood_6" />Tics</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMood7" name="cbMood_7" className="add-only" value="Mood_7" />Tremors</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className="eleHeader w-750;">Affect: </span></td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbAffect1" name="cbAffect_1" className="add-only" value="Affect_1" />Full range </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbAffect2" name="cbAffect_2" className="add-only" value="Affect_2" />Calm</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbAffect3" name="cbAffect_3" className="add-only" value="Affect_3" />Happy </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbAffect4" name="cbAffect_4" className="add-only" value="Affect_4" />Constricted </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbAffect5" name="cbAffect_5" className="add-only" value="Affect_5" />Labile</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbAffect6" name="cbAffect_6" className="add-only" value="Affect_6" />Irritable</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbAffect7" name="cbAffect_7" className="add-only" value="Affect_7" />Blunted</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbAffect8" name="cbAffect_8" className="add-only" value="Affect_8" />Flat</td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className="eleHeader w-750;">Speech: </span></td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbSpeech1" name="cbSpeech_1" className="add-only" value="Speech_" />Appropriate</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbSpeech2" name="cbSpeech_2" className="add-only" value="Speech_" />Hyper-verbal</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbSpeech3" name="cbSpeech_3" className="add-only" value="Speech_" />Pressure speech </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbSpeech4" name="cbSpeech_4" className="add-only" value="Speech_" />Slow </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbSpeech5" name="cbSpeech_5" className="add-only" value="Speech_" />Soft</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbSpeech6" name="cbSpeech_6" className="add-only" value="Speech_" />Loud</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className="eleHeader w-750;">Thought Processes:</span></td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtProcesses1" name="cbThoughtProcesses_1" className="add-only" value="ThoughtProcesses_1" />Goal Directed </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtProcesses2" name="cbThoughtProcesses_2" className="add-only" value="ThoughtProcesses_2" />FOI</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtProcesses3" name="cbThoughtProcesses_3" className="add-only" value="ThoughtProcesses_3" />Tangential</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtProcesses4" name="cbThoughtProcesses_4" className="add-only" value="ThoughtProcesses_4" />Circumstantial </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtProcesses5" name="cbThoughtProcesses_5" className="add-only" value="ThoughtProcesses_5" />Racing thoughts </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtProcesses6" name="cbThoughtProcesses_6" className="add-only" value="ThoughtProcesses_6" />Blocking </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtProcesses7" name="cbThoughtProcesses_7" className="add-only" value="ThoughtProcesses_7" />Within Normal Limits </td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className="eleHeader w-750;">Thought Content:</span></td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtContent1" name="cbThoughtContent_1" className="add-only" value="ThoughtContent_1" />Delusions </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtContent2" name="cbThoughtContent_2" className="add-only" value="ThoughtContent_2" />Obsessions</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtContent3" name="cbThoughtContent_3" className="add-only" value="ThoughtContent_3" />Compulsions </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtContent4" name="cbThoughtContent_4" className="add-only" value="ThoughtContent_4" />Ideas of Reference</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtContent5" name="cbThoughtContent_5" className="add-only" value="ThoughtContent_5" />Phobia</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtContent6" name="cbThoughtContent_6" className="add-only" value="ThoughtContent_6" />Preoccupation</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtContent7" name="cbThoughtContent_7" className="add-only" value="ThoughtContent_7" />Paranoia </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtContent8" name="cbThoughtContent_8" className="add-only" value="ThoughtContent_8" />HI  </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtContent9" name="cbThoughtContent_9" className="add-only" value="ThoughtContent_9" />SI </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbThoughtContent10" name="cbThoughtContent_10" className="add-only" value="ThoughtContent_10" />Within Normal Limits</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className="eleHeader w-750;">Perceptual Disturbance:</span></td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbPerceptualDisturbance1" name="cbPerceptualDisturbance_1" className="add-only" value="PerceptualDisturbance_1" />AH </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbPerceptualDisturbance2" name="cbPerceptualDisturbance_2" className="add-only" value="PerceptualDisturbance_2" />VH</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbPerceptualDisturbance3" name="cbPerceptualDisturbance_3" className="add-only" value="PerceptualDisturbance_3" />Delusions</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbPerceptualDisturbance4" name="cbPerceptualDisturbance_4" className="add-only" value="PerceptualDisturbance_4" />N/A </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className="eleHeader w-750;">Insight/Judgment/Impulse Control:</span></td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbImpulseControl1" name="cbImpulseControl_1" className="add-only" value="ImpulseControl_1" />Good</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbImpulseControl2" name="cbImpulseControl_2" className="add-only" value="ImpulseControl_2" />Fair</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbImpulseControl3" name="cbImpulseControl_3" className="add-only" value="ImpulseControl_3" />Poor</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbImpulseControl4" name="cbImpulseControl_4" className="add-only" value="ImpulseControl_4" />Appropriate for age</td>
                    </tr>
                    <tr>
                        <td className="w-750">
                            <input type="checkbox" id="cbImpulseControl5" name="cbImpulseControl_5" className="add-only" value="ImpulseControl_5" />Appropriate for situation or difficulty</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className="eleHeader w-750;">Reliability of Information: </span></td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbReliabilitInformationy1" name="cbReliabilitInformationy_1" className="add-only" value="ReliabilityInformation_1" />Very Good</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbReliabilitInformationy2" name="cbReliabilitInformationy_2" className="add-only" value="ReliabilityInformation_2" />Good</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbReliabilitInformationy3" name="cbReliabilitInformationy_3" className="add-only" value="ReliabilityInformation_3" />Fair  </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbReliabilitInformationy4" name="cbReliabilitInformationy_4" className="add-only" value="ReliabilityInformation_4" />Poor</td>
                    </tr>
                </table>
                <strong>Vitals</strong>
                <table>
                    <tr>
                        <td className="w-250"><span className="eleHeader w-250;">Blood Pressure</span></td>
                        <td className="w-250"><span className="eleHeader w-250;">Weight</span></td>
                        <td className="w-250"><span className="eleHeader w-250;">Height</span></td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="text" id="txtBloodPressure" name="txtBloodPressure" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtWeight" name="txtWeight" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtHeight" name="txtHeight" className="add-only" />
                        </td>
                    </tr>
                </table>


                <h3>Current Medications & Side effects:</h3>
                <p>
                    (Complete MARS if this is the 1st follow-up since newly prescribed meds):
                </p>

                <p>
                    <span className="eleHeader">Medication #1</span>
                </p>
                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader noprint w-750;">Medication Name*</span>
                            <input type="text" name="txtMedicationNameClientProfile_1" id="txtMedicationNameClientProfile_1" className="add-only" data-display-name="Medication Name" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300">
                            <span className="eleHeader noprint">Dosage/Frequency*</span>
                            <input type="text" name="txtDosageClientProfile_1" id="txtDosageClientProfile_1" className=" add-only" data-display-name="Dosage/Frequency" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader noprint">Purpose for taking*</span>
                            <input type="text" name="txtPurposeClientProfile_1" id="txtPurposeClientProfile_1" className=" add-only" data-display-name="Purpose for taking" />
                        </td>
                        <td className="w-200">
                            <span className="eleHeader noprint">Prescribed by*</span>
                            <input type="text" name="txtPrescribedByClientProfile_1" id="txtPrescribedByClientProfile_1" className="add-only " data-display-name="Prescribed by" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication11" name="cbMedication_11" className="add-only" value="Medication_11" />
                            <strong>qd</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication12" name="cbMedication_12" className="add-only" value="Medication_12" />
                            <strong>BID</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication13" name="cbMedication_13" className="add-only" value="Medication_13" />
                            <strong>TID</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication14" name="cbMedication_14" className="add-only" value="Medication_14" />
                            <strong>QID</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication15" name="cbMedication_15" className="add-only" value="Medication_15" />
                            <strong>P.O.</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication16" name="cbMedication_16" className="add-only" value="Medication_16" />
                            <strong>PRN</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication17" name="cbMedication_17" className="add-only" value="Medication_17" />
                            <strong>IM</strong>
                        </td>
                    </tr>

                </table>
                <table>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects11" name="cbMedicationsSideEffects_11" className="add-only" value="MedicationsSideEffects_11" />Sleep Disturbances</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects12" name="cbMedicationsSideEffects_12" className="add-only" value="MedicationsSideEffects_12" />Eating Disturbances</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects13" name="cbMedicationsSideEffects_13" className="add-only" value="MedicationsSideEffects_13" />Tics</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects14" name="cbMedicationsSideEffects_14" className="add-only" value="MedicationsSideEffects_14" />Muscle Stiffness</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects15" name="cbMedicationsSideEffects_15" className="add-only" value="MedicationsSideEffects_15" />Dystonia</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects16" name="cbMedicationsSideEffects_16" className="add-only" value="MedicationsSideEffects_16" />Dizziness</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects17" name="cbMedicationsSideEffects_17" className="add-only" value="MedicationsSideEffects_17" />Nausea </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects18" name="cbMedicationsSideEffects_18" className="add-only" value="MedicationsSideEffects_18" />Tremor</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects19" name="cbMedicationsSideEffects_19" className="add-only" value="MedicationsSideEffects_19" />Rash </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects110" name="cbMedicationsSideEffects_110" className="add-only" value="MedicationsSideEffects_110" />Diarrhea</td>
                        <td className="w-375">
                            <input type="checkbox" id="cbMedicationsSideEffects111" name="cbMedicationsSideEffects_111" className="add-only" value="MedicationsSideEffects_111" />No Side Effects Reported </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects112" name="cbMedicationsSideEffects_112" className="add-only" value="MedicationsSideEffects_112" />Other</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input className="w-177.5" type="text" id="txtMedicationsSideEffects_112" name="txtMedicationsSideEffects_112" />
                        </td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className="eleHeader">Medication #2</span>
                </p>
                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader noprint">Medication Name*</span>
                            <input type="text" name="txtMedicationNameClientProfile_2" id="txtMedicationNameClientProfile_2" className="add-only" data-display-name="Medication Name" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300">
                            <span className="eleHeader noprint">Dosage/Frequency*</span>
                            <input type="text" name="txtDosageClientProfile_2" id="txtDosageClientProfile_2" className=" add-only" data-display-name="Dosage/Frequency" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader noprint">Purpose for taking*</span>
                            <input type="text" name="txtPurposeClientProfile_2" id="txtPurposeClientProfile_2" className=" add-only" data-display-name="Purpose for taking" />
                        </td>
                        <td className="w-200">
                            <span className="eleHeader noprint">Prescribed by*</span>
                            <input type="text" name="txtPrescribedByClientProfile_2" id="txtPrescribedByClientProfile_2" className="add-only " data-display-name="Prescribed by" />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication21" name="cbMedication_21" className="add-only" value="Medication_21" />
                            <strong>qd</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication22" name="cbMedication_22" className="add-only" value="Medication_22" />
                            <strong>BID</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication23" name="cbMedication_23" className="add-only" value="Medication_23" />
                            <strong>TID</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication24" name="cbMedication_24" className="add-only" value="Medication_24" />
                            <strong>QID</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication25" name="cbMedication_25" className="add-only" value="Medication_25" />
                            <strong>P.O.</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication26" name="cbMedication_26" className="add-only" value="Medication_26" />
                            <strong>PRN</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication27" name="cbMedication_27" className="add-only" value="Medication_27" />
                            <strong>IM</strong>
                        </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects21" name="cbMedicationsSideEffects_21" className="add-only" value="MedicationsSideEffects_21" />Sleep Disturbances</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects22" name="cbMedicationsSideEffects_22" className="add-only" value="MedicationsSideEffects_22" />Eating Disturbances</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects23" name="cbMedicationsSideEffects_23" className="add-only" value="MedicationsSideEffects_23" />Tics</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects24" name="cbMedicationsSideEffects_24" className="add-only" value="MedicationsSideEffects_24" />Muscle Stiffness</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects25" name="cbMedicationsSideEffects_25" className="add-only" value="MedicationsSideEffects_25" />Dystonia</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects26" name="cbMedicationsSideEffects_26" className="add-only" value="MedicationsSideEffects_26" />Dizziness</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects27" name="cbMedicationsSideEffects_27" className="add-only" value="MedicationsSideEffects_27" />Nausea </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects28" name="cbMedicationsSideEffects_28" className="add-only" value="MedicationsSideEffects_28" />Tremor</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects29" name="cbMedicationsSideEffects_29" className="add-only" value="MedicationsSideEffects_29" />Rash </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects210" name="cbMedicationsSideEffects_210" className="add-only" value="MedicationsSideEffects_210" />Diarrhea</td>
                            <td className="w-375">
                            <input type="checkbox" id="cbMedicationsSideEffects211" name="cbMedicationsSideEffects_211" className="add-only" value="MedicationsSideEffects_211" />No Side Effects Reported </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects212" name="cbMedicationsSideEffects_212" className="add-only" value="MedicationsSideEffects_212" />Other</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input className="w-177.5" type="text" id="txtMedicationsSideEffects_212" name="txtMedicationsSideEffects_212" />
                        </td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className="eleHeader">Medication #3</span>
                </p>
                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader noprint">Medication Name*</span>
                            <input type="text" name="txtMedicationNameClientProfile_3" id="txtMedicationNameClientProfile_3" className="add-only" data-display-name="Medication Name" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300">
                            <span className="eleHeader noprint">Dosage/Frequency*</span>
                            <input type="text" name="txtDosageClientProfile_3" id="txtDosageClientProfile_3" className=" add-only" data-display-name="Dosage/Frequency" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader noprint">Purpose for taking*</span>
                            <input type="text" name="txtPurposeClientProfile_3" id="txtPurposeClientProfile_3" className=" add-only" data-display-name="Purpose for taking" />
                        </td>
                        <td className="w-200">
                            <span className="eleHeader noprint">Prescribed by*</span>
                            <input type="text" name="txtPrescribedByClientProfile_3" id="txtPrescribedByClientProfile_3" className="add-only " data-display-name="Prescribed by" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication31" name="cbMedication_31" className="add-only" value="Medication_31" />
                            <strong>qd</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication32" name="cbMedication_32" className="add-only" value="Medication_32" />
                            <strong>BID</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication33" name="cbMedication_33" className="add-only" value="Medication_33" />
                            <strong>TID</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication34" name="cbMedication_34" className="add-only" value="Medication_34" />
                            <strong>QID</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication35" name="cbMedication_35" className="add-only" value="Medication_35" />
                            <strong>P.O.</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication36" name="cbMedication_36" className="add-only" value="Medication_36" />
                            <strong>PRN</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication37" name="cbMedication_37" className="add-only" value="Medication_37" />
                            <strong>IM</strong>
                        </td>
                    </tr>

                </table>
                <table>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects31" name="cbMedicationsSideEffects_31" className="add-only" value="MedicationsSideEffects_31" />Sleep Disturbances</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects32" name="cbMedicationsSideEffects_32" className="add-only" value="MedicationsSideEffects_32" />Eating Disturbances</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects33" name="cbMedicationsSideEffects_33" className="add-only" value="MedicationsSideEffects_33" />Tics</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects34" name="cbMedicationsSideEffects_34" className="add-only" value="MedicationsSideEffects_34" />Muscle Stiffness</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects35" name="cbMedicationsSideEffects_35" className="add-only" value="MedicationsSideEffects_35" />Dystonia</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects36" name="cbMedicationsSideEffects_36" className="add-only" value="MedicationsSideEffects_36" />Dizziness</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects37" name="cbMedicationsSideEffects_37" className="add-only" value="MedicationsSideEffects_37" />Nausea </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects38" name="cbMedicationsSideEffects_38" className="add-only" value="MedicationsSideEffects_38" />Tremor</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects39" name="cbMedicationsSideEffects_39" className="add-only" value="MedicationsSideEffects_39" />Rash </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects310" name="cbMedicationsSideEffects_310" className="add-only" value="MedicationsSideEffects_310" />Diarrhea</td>
                            <td className="w-375">
                            <input type="checkbox" id="cbMedicationsSideEffects311" name="cbMedicationsSideEffects_311" className="add-only" value="MedicationsSideEffects_311" />No Side Effects Reported </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects312" name="cbMedicationsSideEffects_312" className="add-only" value="MedicationsSideEffects_312" />Other</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="text" id="txtMedicationsSideEffects_312" name="txtMedicationsSideEffects_312" className="add-only" />
                        </td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className="eleHeader">Medication #4</span>
                </p>

                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader noprint">Medication Name*</span>
                            <input type="text" name="txtMedicationNameClientProfile_4" id="txtMedicationNameClientProfile_4" className="add-only" data-display-name="Medication Name" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-300">
                            <span className="eleHeader noprint">Dosage/Frequency*</span>
                            <input type="text" name="txtDosageClientProfile_4" id="txtDosageClientProfile_4" className=" add-only" data-display-name="Dosage/Frequency" />
                        </td>
                        <td className="w-250">
                            <span className="eleHeader noprint">Purpose for taking*</span>
                            <input type="text" name="txtPurposeClientProfile_4" id="txtPurposeClientProfile_4" className=" add-only" data-display-name="Purpose for taking" />
                        </td>
                        <td className="w-200">
                            <span className="eleHeader noprint">Prescribed by*</span>
                            <input type="text" name="txtPrescribedByClientProfile_4" id="txtPrescribedByClientProfile_4" className="add-only " data-display-name="Prescribed by" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication1" name="cbMedication_1" className="add-only" value="Medication_1" />
                            <strong>qd</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication2" name="cbMedication_2" className="add-only" value="Medication_2" />
                            <strong>BID</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication3" name="cbMedication_3" className="add-only" value="Medication_3" />
                            <strong>TID</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication4" name="cbMedication_4" className="add-only" value="Medication_4" />
                            <strong>QID</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication5" name="cbMedication_5" className="add-only" value="Medication_5" />
                            <strong>P.O.</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication6" name="cbMedication_6" className="add-only" value="Medication_6" />
                            <strong>PRN</strong>
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" id="cbMedication7" name="cbMedication_7" className="add-only" value="Medication_7" />
                            <strong>IM</strong>
                        </td>
                    </tr>

                </table>
                <table>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects41" name="cbMedicationsSideEffects_41" className="add-only" value="MedicationsSideEffects_41" />Sleep Disturbances</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects42" name="cbMedicationsSideEffects_42" className="add-only" value="MedicationsSideEffects_42" />Eating Disturbances</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects43" name="cbMedicationsSideEffects_43" className="add-only" value="MedicationsSideEffects_43" />Tics</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects44" name="cbMedicationsSideEffects_44" className="add-only" value="MedicationsSideEffects_44" />Muscle Stiffness</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects45" name="cbMedicationsSideEffects_45" className="add-only" value="MedicationsSideEffects_45" />Dystonia</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects46" name="cbMedicationsSideEffects_46" className="add-only" value="MedicationsSideEffects_46" />Dizziness</td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects47" name="cbMedicationsSideEffects_47" className="add-only" value="MedicationsSideEffects_47" />Nausea </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects48" name="cbMedicationsSideEffects_48" className="add-only" value="MedicationsSideEffects_48" />Tremor</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects49" name="cbMedicationsSideEffects_49" className="add-only" value="MedicationsSideEffects_49" />Rash </td>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects410" name="cbMedicationsSideEffects_410" className="add-only" value="MedicationsSideEffects_410" />Diarrhea</td>
                            <td className="w-375">
                            <input type="checkbox" id="cbMedicationsSideEffects411" name="cbMedicationsSideEffects_411" className="add-only" value="MedicationsSideEffects_411" />No Side Effects Reported </td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="checkbox" id="cbMedicationsSideEffects412" name="cbMedicationsSideEffects_412" className="add-only" value="MedicationsSideEffects_412" />Other</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-187">
                            <input type="text" id="txtMedicationsSideEffects_412" name="txtMedicationsSideEffects_412" className="add-only" />
                        </td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                        <td className="w-187">&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <span className="eleHeader">Labs Requested:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-125'>
                            <input type="radio" id="rbLabsRequested_Yes" name="rbLabsRequested" className="add-only" value="Yes" />Yes
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbLabsRequested_No" name="rbLabsRequested" className="add-only" value="No" />No
                        </td>
                    </tr>

                </table>
                <p>
                    <span className="eleHeader">Labs Reviewed:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-125'>
                            <input type="radio" id="rbLabsReviewed_Yes" name="rbLabsReviewed" className="add-only" value="Yes" />Yes
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbLabsReviewed_No" name="rbLabsReviewed" className="add-only" value="No" />No
                        </td>
                    </tr>

                </table>

                <p>
                    <span className="eleHeader">Lab Notes : </span>
                    <span className="small block">(if applicable)</span>
                    <textarea id="txtLabNotes" name="txtLabNotes" className=" add-only"></textarea>
                </p>
                <p>
                    <h3>PLAN:</h3>
                    <span className="eleHeader">DISCONTINUE THE FOLLOWING MEDICATIONS:</span>

                    <input type="checkbox" id="cbMedicationDiscontinue1" name="cbMedicationDiscontinue_1" className="add-only" value="MedicationDiscontinue_1" /> Medication #1 &nbsp;

                    <input type="checkbox" id="cbMedicationDiscontinue2" name="cbMedicationDiscontinue_2" className="add-only" value="MedicationDiscontinue_2" /> Medication #2 &nbsp;

                    <input type="checkbox" id="cbMedicationDiscontinue3" name="cbMedicationDiscontinue_3" className="add-only" value="MedicationDiscontinue_3" /> Medication #3 &nbsp;

                    <input type="checkbox" id="cbMedicationDiscontinue4" name="cbMedicationDiscontinue_4" className="add-only" value="MedicationDiscontinue_4" /> Medication #4

                </p>


                <span className="eleHeader">START NEW MEDICATIONS: </span>
                <span className="small block">(complete Medication Informed Consent form)</span>
                <span className="eleHeader">Concerta</span>
                <input type="checkbox" id="cbConcertaDosage1" name="cbConcertaDosage_1" className="add-only" value="ConcertaDosage_1" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtConcertaDosage_1" name="txtConcertaDosage_1" className="add-only"></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication11" name="cbNewMedication_11" className="add-only" value="NewMedication_11" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication12" name="cbNewMedication_12" className="add-only" value="NewMedication_12" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication13" name="cbNewMedication_13" className="add-only" value="NewMedication_13" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication14" name="cbNewMedication_14" className="add-only" value="NewMedication_14" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication15" name="cbNewMedication_15" className="add-only" value="NewMedication_15" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication16" name="cbNewMedication_16" className="add-only" value="NewMedication_16" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication17" name="cbNewMedication_17" className="add-only" value="NewMedication_17" />IM
                    </td>
                </tr>
                <span className="eleHeader">Metadate CD </span>
                <input type="checkbox" id="cbMetadateDosage_2" name="cbMetadateDosage_2" className="add-only" value="MetadateDosage_2" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtMetadateDosage_2" name="txtMetadateDosage_2" className=" add-only"></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication21" name="cbNewMedication_21" className="add-only" value="NewMedication_21" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication22" name="cbNewMedication_22" className="add-only" value="NewMedication_22" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication23" name="cbNewMedication_23" className="add-only" value="NewMedication_23" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication24" name="cbNewMedication_24" className="add-only" value="NewMedication_24" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication25" name="cbNewMedication_25" className="add-only" value="NewMedication_25" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication26" name="cbNewMedication_26" className="add-only" value="NewMedication_26" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication27" name="cbNewMedication_27" className="add-only" value="NewMedication_27" />IM
                    </td>
                </tr>
                <span className="eleHeader">Methylphenietate</span>
                <input type="checkbox" id="cbMethylphenietateDosage3" name="cbMethylphenietateDosage_3" className="add-only" value="DosageMethylphenietate_3" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtMethylphenietateDosage_3" name="txtMethylphenietateDosage_3" className=" add-only"></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication31" name="cbNewMedication_31" className="add-only" value="NewMedication_31" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication32" name="cbNewMedication_32" className="add-only" value="NewMedication_32" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication33" name="cbNewMedication_33" className="add-only" value="NewMedication_33" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication34" name="cbNewMedication_34" className="add-only" value="NewMedication_34" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication35" name="cbNewMedication_35" className="add-only" value="NewMedication_35" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication36" name="cbNewMedication_36" className="add-only" value="NewMedication_36" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication37" name="cbNewMedication_37" className="add-only" value="NewMedication_37" />IM
                    </td>
                </tr>
                <span className="eleHeader">Adderall XR</span>
                <input type="checkbox" id="cbAdderallXrDosage4" name="cbAdderallXrDosage_4" className="add-only" value="Aadd-onlyerallXrDosage_4" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtAdderallXrDosage_4" name="txtAdderallXrDosage_4" className=" add-only"></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication41" name="cbNewMedication_41" className="add-only" value="NewMedication_41" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication42" name="cbNewMedication_42" className="add-only" value="NewMedication_42" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication43" name="cbNewMedication_43" className="add-only" value="NewMedication_43" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication44" name="cbNewMedication_44" className="add-only" value="NewMedication_44" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication45" name="cbNewMedication_45" className="add-only" value="NewMedication_45" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication46" name="cbNewMedication_46" className="add-only" value="NewMedication_46" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication47" name="cbNewMedication_47" className="add-only" value="NewMedication_47" />IM
                    </td>
                </tr>
                <span className="eleHeader">Adderall </span>
                <input type="checkbox" id="cbAdderallDosage5" name="cbAdderallDosage_5" className="add-only" value="cbAdderallDosage_5" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtAdderallDosage5" name="txtAdderallDosage_5" className=" add-only"></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication51" name="cbNewMedication_51" className="add-only" value="NewMedication_51" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication52" name="cbNewMedication_52" className="add-only" value="NewMedication_52" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication53" name="cbNewMedication_53" className="add-only" value="NewMedication_53" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication54" name="cbNewMedication_54" className="add-only" value="NewMedication_54" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication55" name="cbNewMedication_55" className="add-only" value="NewMedication_55" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication56" name="cbNewMedication_56" className="add-only" value="NewMedication_56" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication57" name="cbNewMedication_57" className="add-only" value="NewMedication_57" />IM
                    </td>
                </tr>
                <span className="eleHeader">Celexa</span>
                <input type="checkbox" id="cbCelexaDosage6" name="cbCelexaDosage_6" className="add-only" value="CelexaDosage_6" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtCelexaDosage_6" name="txtCelexaDosage_6" className=" add-only"></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication61" name="cbNewMedication_61" className="add-only" value="NewMedication_61" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication62" name="cbNewMedication_62" className="add-only" value="NewMedication_62" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication63" name="cbNewMedication_63" className="add-only" value="NewMedication_63" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication64" name="cbNewMedication_64" className="add-only" value="NewMedication_64" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication65" name="cbNewMedication_65" className="add-only" value="NewMedication_65" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication66" name="cbNewMedication_66" className="add-only" value="NewMedication_66" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication67" name="cbNewMedication_67" className="add-only" value="NewMedication_67" />IM
                    </td>
                </tr>
                <span className="eleHeader">Lexapro</span>
                <input type="checkbox" id="cbLexaproDosage7" name="cbLexaproDosage_7" className="add-only" value="LexaproDosage_7" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtLexaproDosage_7" name="txtLexaproDosage_7" className=" add-only"></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication71" name="cbNewMedication_71" className="add-only" value="NewMedication_71" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication72" name="cbNewMedication_72" className="add-only" value="NewMedication_72" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication73" name="cbNewMedication_73" className="add-only" value="NewMedication_73" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication74" name="cbNewMedication_74" className="add-only" value="NewMedication_74" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication75" name="cbNewMedication_75" className="add-only" value="NewMedication_75" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication76" name="cbNewMedication_76" className="add-only" value="NewMedication_76" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication77" name="cbNewMedication_77" className="add-only" value="NewMedication_77" />IM
                    </td>
                </tr>
                <span className="eleHeader">Wellbutrin XL</span>
                <input type="checkbox" id="cbWellbutrinXlDosage8" name="cbWellbutrinXlDosage_8" className="add-only" value="WellbutrinXlDosage_8" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtWellbutrinXlDosage_8" name="txtWellbutrinXlDosage_8" className=" add-only"></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication81" name="cbNewMedication_81" className="add-only" value="NewMedication_81" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication82" name="cbNewMedication_82" className="add-only" value="NewMedication_82" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication83" name="cbNewMedication_83" className="add-only" value="NewMedication_83" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication84" name="cbNewMedication_84" className="add-only" value="NewMedication_84" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication85" name="cbNewMedication_85" className="add-only" value="NewMedication_85" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication86" name="cbNewMedication_86" className="add-only" value="NewMedication_86" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication87" name="cbNewMedication_87" className="add-only" value="NewMedication_87" />IM
                    </td>
                </tr>
                <span className="eleHeader">Zoloft</span>
                <input type="checkbox" id="cbZoloftDosage9" name="cbZoloftDosage_9" className="add-only" value="ZoloftDosage_9" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtZoloftDosage_9" name="txtZoloftDosage_9" className=" add-only"></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication91" name="cbNewMedication_91" className="add-only" value="NewMedication_91" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication92" name="cbNewMedication_92" className="add-only" value="NewMedication_92" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication93" name="cbNewMedication_93" className="add-only" value="NewMedication_93" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication94" name="cbNewMedication_94" className="add-only" value="NewMedication_94" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication95" name="cbNewMedication_95" className="add-only" value="NewMedication_95" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication96" name="cbNewMedication_96" className="add-only" value="NewMedication_96" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication97" name="cbNewMedication_97" className="add-only" value="NewMedication_97" />IM
                    </td>
                </tr>
                <span className="eleHeader">Trileptal</span>
                <input type="checkbox" id="cbTrileptalDosage10" name="cbTrileptalDosage_10" className="add-only" value="TrileptalDosage_10" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtTrileptalDosage_10" name="txtTrileptalDosage_10" className=" add-only"></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication101" name="cbNewMedication_101" className="add-only" value="NewMedication_101" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication102" name="cbNewMedication_102" className="add-only" value="NewMedication_102" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication103" name="cbNewMedication_103" className="add-only" value="NewMedication_103" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication104" name="cbNewMedication_104" className="add-only" value="NewMedication_104" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication105" name="cbNewMedication_105" className="add-only" value="NewMedication_105" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication106" name="cbNewMedication_106" className="add-only" value="NewMedication_106" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication107" name="cbNewMedication_107" className="add-only" value="NewMedication_107" />IM
                    </td>
                </tr>
                <span className="eleHeader">Depakote</span>
                <input type="checkbox" id="cbDepakoteDosage11" name="cbDepakoteDosage_11" className="add-only" value="DepakoteDosage_11" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtDepakoteDosage_11" name="txtDepakoteDosage_11" className=" add-only"></textarea>
                    </td>
                </tr>

                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication111" name="cbNewMedication_111" className="add-only" value="NewMedication_111" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication112" name="cbNewMedication_112" className="add-only" value="NewMedication_112" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication113" name="cbNewMedication_113" className="add-only" value="NewMedication_113" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication114" name="cbNewMedication_114" className="add-only" value="NewMedication_114" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication115" name="cbNewMedication_115" className="add-only" value="NewMedication_115" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication116" name="cbNewMedication_116" className="add-only" value="NewMedication_116" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication117" name="cbNewMedication_117" className="add-only" value="NewMedication_117" />IM
                    </td>
                </tr>
                <span className="eleHeader">Abilify</span>
                <input type="checkbox" id="cbAbilifyDosage12" name="cbAbilifyDosage_12" className="add-only" value="AbilifyDosage_12" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtAbilifyDosage_12" name="txtAbilifyDosage_12" className=" add-only"></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication121" name="cbNewMedication_121" className="add-only" value="NewMedication_121" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication122" name="cbNewMedication_122" className="add-only" value="NewMedication_122" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication123" name="cbNewMedication_123" className="add-only" value="NewMedication_123" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication124" name="cbNewMedication_124" className="add-only" value="NewMedication_124" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication125" name="cbNewMedication_125" className="add-only" value="NewMedication_125" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication126" name="cbNewMedication_126" className="add-only" value="NewMedication_126" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication127" name="cbNewMedication_127" className="add-only" value="NewMedication_127" />IM
                    </td>
                </tr>
                <span className="eleHeader">Risperdal</span>
                <input type="checkbox" id="cbRisperdalDosage13" name="cbRisperdalDosage_13" className="add-only" value="RisperdalDosage_13" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtRisperdalDosage_13" name="txtRisperdalDosage_13" className=" add-only"></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication131" name="cbNewMedication_131" className="add-only" value="NewMedication_131" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication132" name="cbNewMedication_132" className="add-only" value="NewMedication_132" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication133" name="cbNewMedication_133" className="add-only" value="NewMedication_133" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication134" name="cbNewMedication_134" className="add-only" value="NewMedication_134" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication135" name="cbNewMedication_135" className="add-only" value="NewMedication_135" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication136" name="cbNewMedication_136" className="add-only" value="NewMedication_136" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication137" name="cbNewMedication_137" className="add-only" value="NewMedication_137" />IM
                    </td>
                </tr>
                <span className="eleHeader">Seroquel</span>
                <input type="checkbox" id="cbSeroquelDosage14" name="cbSeroquelDosage_14" className="add-only" value="SeroquelDosage_14" />dosage
                <tr>
                    <td className='w-750'>
                        <textarea id="txtSeroquelDosage_14" name="txtSeroquelDosage_14" className=" add-only"></textarea>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication141" name="cbNewMedication_141" className="add-only" value="NewMedication_141" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication142" name="cbNewMedication_142" className="add-only" value="NewMedication_142" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication143" name="cbNewMedication_143" className="add-only" value="NewMedication_143" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication144" name="cbNewMedication_144" className="add-only" value="NewMedication_144" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication145" name="cbNewMedication_145" className="add-only" value="NewMedication_145" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication146" name="cbNewMedication_146" className="add-only" value="NewMedication_146" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication147" name="cbNewMedication_147" className="add-only" value="NewMedication_147" />IM
                    </td>
                </tr>
                <span className="eleHeader">Geodon</span>
                <input type="checkbox" id="cbGeodonDosage15" name="cbGeodonDosage_15" className="add-only" value="GeodonDosage_15" />dosage
                <tr>
                    <td className='w-750'>
                    </td>
                </tr>
                <tr>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication151" name="cbNewMedication_151" className="add-only" value="NewMedication_151" />qd
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication152" name="cbNewMedication_152" className="add-only" value="NewMedication_152" />BID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication153" name="cbNewMedication_153" className="add-only" value="NewMedication_153" />TID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication154" name="cbNewMedication_154" className="add-only" value="NewMedication_154" />QID
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication155" name="cbNewMedication_155" className="add-only" value="NewMedication_155" />P.O.
                    </td>
                    <td className='w-60'>
                        <input type="checkbox" id="cbNewMedication156" name="cbNewMedication_156" className="add-only" value="NewMedication_156" />PRN
                    </td>
                    <td className='w-50'>
                        <input type="checkbox" id="cbNewMedication157" name="cbNewMedication_157" className="add-only" value="NewMedication_157" />IM
                    </td>
                </tr>
                <strong>Other </strong>
                <input type="checkbox" id="cbNewMedicationOther" name="cbNewMedicationOther" className="add-only" value="NewMedicationOther" />

                <textarea id="txtNewMedicationOther" name="txtNewMedicationOther" className=" add-only"></textarea>

                <span className="eleHeader">RTC : </span>
                <span className="small block">(Return to Clinic)</span>
                <tr>
                    <td className='w-75'>
                        <input type="checkbox" id="cbReturnClinic1" name="cbReturnClinic_1" className="add-only" value="ReturnClinic_1" />1mo
                    </td>
                    <td className='w-75'>
                        <input type="checkbox" id="cbReturnClinic2" name="cbReturnClinic_2" className="add-only" value="ReturnClinic_2" />2mo
                    </td>
                    <td className='w-75'>
                        <input type="checkbox" id="cbReturnClinic3" name="cbReturnClinic_3" className="add-only" value="ReturnClinic_3" />3mo
                    </td>
                    <td className='w-75'>
                        <input type="checkbox" id="cbReturnClinic4" name="cbReturnClinic_4" className="add-only" value="ReturnClinic_4" />4mo
                    </td>
                    <td className='w-75'>
                        <input type="checkbox" id="cbReturnClinic5" name="cbReturnClinic_5" className="add-only" value="ReturnClinic_5" />5mo
                    </td>
                    <td className='w-75'>
                        <input type="checkbox" id="cbReturnClinic6" name="cbReturnClinic_6" className="add-only" value="ReturnClinic_6" />6mo
                    </td>
                    <td className='w-75'>
                        <input type="checkbox" id="cbReturnClinic7" name="cbReturnClinic_7" className="add-only" value="ReturnClinic_7" />12mo
                    </td>
                    <td className='w-100'>
                        <input type="checkbox" id="cbReturnClinic8" name="cbReturnClinic_8" className="add-only" value="ReturnClinic_8" />As Needed
                    </td>
                </tr>
                <span className="eleHeader">NEW / UPDATED DIAGNOSIS: </span>
                <input type="checkbox" id="cbNewUpdateDiagnosis" name="cbNewUpdateDiagnosis" className="add-only" value="NewUpdateDiagnosis" />N/A - see header for current diagnosis

                <strong>1</strong>
                <br />
                <textarea id="txtNewUpdateDiagnosis_1" name="txtNewUpdateDiagnosis_1" className=" add-only"></textarea>

                <strong>2</strong>
                <br />
                <textarea id="txtNewUpdateDiagnosis_2" name="txtNewUpdateDiagnosis_2" className=" add-only"></textarea>

                <strong>3</strong>
                <br />
                <textarea id="txtNewUpdateDiagnosis_3" name="txtNewUpdateDiagnosis_3" className=" add-only"></textarea>

                <strong>Additional Comments/Plan</strong>
                <tr>
                    <td className='w-750'>
                        <textarea id="txtAdditionalComments" name="txtAdditionalComments" className=" add-only"></textarea>
                    </td>
                </tr>
                <table>
                    <tr>
                        <td className="w-375 signature">&nbsp;</td>
                        <td className="w-375 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Physician Signature/Title:</td>
                        <td className="w-375 small">Date:</td>
                    </tr>
                    <tr>
                        <td className="w-750 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-750 small">Please Type/Print Name and Title:</td>
                    </tr>
                </table>
            </div>
        </form>
    )
}